import React from 'react';
import { UlfahAdvertorial } from './pages/UlfahAdvertorial';
export function App() {
  return <UlfahAdvertorial data-id="element-0" />;
}